<template>
  <transition name="custom-fade">
    <div class="cover" @click="$emit('click')">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  created () {
    document.body.style.overflow = 'hidden'
  },
  destroyed () {
    document.body.style.overflow = ''
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);
}
.cover-enter-active, .cover-leave-active {
  transition: opacity .5s;
}
.cover-enter, .cover-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/cover/Cover.vue